const SECTIONS = [
  {
    title: "1. Éditeur du site",
    paras: [
      "Le présent site internet, accessible à l’adresse labounite.fr, est édité par :",
      { list: [
        "Nom commercial : Labounite",
        "Entrepreneuse individuelle : Mercadé Françoise",
        "Statut juridique : Entreprise individuelle sous le régime micro-entrepreneur (micro-entreprise)",
        "Activité : Création artisanale et vente de vêtements et accessoires faits main au crochet et au tricot.",
        "Adresse professionnelle : 13 lieu dit Chapsieres 15380 Anglards de Salers",
        "Numéro SIREN : 491409793",
        "Numéro SIRET : 49140979300040",
        "Adresse électronique : labounite@gmail.com",
      ] },
      "« TVA non applicable, article 293 B du Code général des impôts. »",
    ],
  },
  {
    title: "2. Directrice de la publication",
    paras: [
      "La directrice de la publication du site est : Mercadé Françoise",
      "Elle est responsable des contenus éditoriaux publiés sur le site, dans les conditions prévues par la législation applicable.",
    ],
  },
  {
    title: "3. Hébergement du site",
    paras: [
      "Le site est hébergé par :",
      { list: [
        "Nom de l’hébergeur : Emergent AI, Inc.",
        "Raison sociale : Orion Industrie",
        "Adresse : 2261 Market Street #4350, San Francisco, CA 94114, États-Unis",
        "Site internet : https://emergent.sh",
      ] },
    ],
  },
  {
    title: "4. Activité et créations artisanales",
    paras: [
      "Labounite propose des créations artisanales de vêtements et d’accessoires réalisés au crochet et au tricot.",
      "Chaque création est conçue avec soin et peut présenter des particularités liées à sa fabrication artisanale : variations de couleurs, de textures, de dimensions ou de finitions.",
      "Les photographies et descriptions présentes sur le site visent à représenter les articles aussi fidèlement que possible. De légères différences peuvent exister entre les photographies et le produit reçu, notamment en raison des réglages d’écran, de l’éclairage ou des caractéristiques propres au travail fait main.",
      "Les caractéristiques essentielles, les dimensions, les matières et les éventuelles particularités de chaque article sont précisées sur sa fiche produit, dans la mesure des informations disponibles.",
    ],
  },
  {
    title: "5. Propriété intellectuelle",
    paras: [
      "L’ensemble des éléments présents sur le site, notamment les textes, photographies, illustrations, logos, éléments graphiques et contenus originaux, est susceptible d’être protégé par le droit de la propriété intellectuelle.",
      "Sauf indication contraire, ces éléments appartiennent à Labounite ou sont utilisés avec l’autorisation de leurs titulaires.",
      "Toute reproduction, représentation, adaptation, diffusion ou exploitation, totale ou partielle, sans autorisation préalable du titulaire des droits, est interdite lorsque cette autorisation est requise par la loi.",
      "Cette disposition ne porte pas atteinte aux exceptions prévues par la législation applicable.",
    ],
  },
  {
    title: "6. Données personnelles",
    paras: [
      "Dans le cadre de son activité, Labounite peut collecter des données personnelles nécessaires au traitement des commandes, à la livraison des produits, à la gestion des demandes des clients et au respect de ses obligations légales.",
      "Les données collectées sont utilisées uniquement pour des finalités déterminées et légitimes, dans la limite de ce qui est nécessaire.",
      "Les personnes concernées disposent, selon les conditions prévues par la réglementation, de droits d’accès, de rectification, d’effacement, de limitation du traitement et, lorsque cela est applicable, d’opposition et de portabilité.",
      "Pour exercer leurs droits ou poser une question relative à leurs données personnelles, les utilisateurs peuvent contacter : labounite@gmail.com",
      "Les informations détaillées concernant les finalités, les bases légales, les durées de conservation, les destinataires des données et les modalités d’exercice des droits sont présentées dans la politique de confidentialité du site.",
      "Il est également possible d’introduire une réclamation auprès de la Commission nationale de l’informatique et des libertés (CNIL).",
    ],
  },
  {
    title: "7. Cookies et autres traceurs",
    paras: [
      "Le site peut utiliser des cookies ou autres traceurs nécessaires à son fonctionnement, ainsi que, le cas échéant, des traceurs de mesure d’audience, de personnalisation ou de publicité.",
      "Lorsque la réglementation l’exige, le consentement préalable de l’utilisateur est recueilli avant le dépôt ou la lecture des traceurs concernés.",
      "L’utilisateur doit pouvoir accepter ou refuser les traceurs soumis au consentement avec une facilité équivalente et modifier ses choix ultérieurement.",
      "Les informations relatives aux traceurs effectivement utilisés, à leurs finalités et à la gestion des préférences sont accessibles dans la politique de cookies ou dans la rubrique dédiée du site.",
    ],
  },
  {
    title: "8. Responsabilité",
    paras: [
      "Labounite s’efforce de fournir sur son site des informations exactes et régulièrement mises à jour.",
      "Toutefois, des erreurs, omissions ou interruptions temporaires peuvent survenir. L’éditeur ne saurait garantir une disponibilité permanente du site ni l’absence totale d’erreurs techniques.",
      "L’éditeur ne peut exclure sa responsabilité que dans les limites autorisées par la législation applicable. Aucune disposition des présentes mentions légales ne saurait priver un consommateur de ses droits impératifs.",
    ],
  },
  {
    title: "9. Liens hypertextes",
    paras: [
      "Le site peut contenir des liens vers des sites internet tiers.",
      "Labounite n’exerce aucun contrôle général sur le contenu de ces sites et ne saurait être tenue responsable de leurs contenus ou de leurs pratiques en matière de confidentialité.",
      "La présence d’un lien ne constitue pas une approbation systématique du site concerné.",
    ],
  },
  {
    title: "10. Conditions générales de vente",
    paras: [
      "Les ventes réalisées sur le site sont régies par les conditions générales de vente (CGV), accessibles sur la page CGV dans la boutique labouniteshop.fr",
      "Les CGV précisent notamment les modalités de commande, les prix, les moyens de paiement, les délais de livraison, le droit de rétractation, les garanties légales et les modalités de règlement des litiges.",
    ],
  },
  {
    title: "11. Médiation de la consommation",
    paras: [
      "Conformément aux dispositions applicables du Code de la consommation, le consommateur peut recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable d’un litige l’opposant à Labounite, après avoir adressé une réclamation écrite préalable à l’entreprise et lorsque les conditions de recevabilité sont remplies.",
      { list: [
        "Médiateur de la consommation : CM2C",
        "Adresse postale : 49 rue de Ponthieu – 75008 PARIS",
        "Site internet : www.cm2c.net",
      ] },
    ],
  },
  {
    title: "12. Droit applicable",
    paras: [
      "Les présentes mentions légales sont soumises au droit français.",
      "En cas de différend, les parties rechercheront, dans la mesure du possible, une solution amiable, sans préjudice des droits dont dispose le consommateur en vertu de la législation applicable.",
      "Les règles de compétence juridictionnelle applicables seront déterminées conformément aux dispositions légales en vigueur.",
    ],
  },
];

const Para = ({ p }) =>
  typeof p === "string" ? (
    <p className="leading-relaxed text-[#1F1C18]/85">{p}</p>
  ) : (
    <ul className="space-y-1.5 pl-5 list-disc marker:text-terracotta text-[#1F1C18]/85">
      {p.list.map((li) => <li key={li}>{li}</li>)}
    </ul>
  );

export default function LegalNotice() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-testid="legal-notice-page">
      <p className="font-accent text-3xl text-terracotta -rotate-2 mb-2">Labounite</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl mb-3">Mentions légales</h1>
      <p className="text-sm text-[#6B655C] mb-10" data-testid="legal-notice-updated">Dernière mise à jour : juin 2026</p>
      <div className="bg-white/70 backdrop-blur-md rounded-3xl p-6 sm:p-10 space-y-10">
        {SECTIONS.map((s) => (
          <section key={s.title} className="space-y-3">
            <h2 className="font-serif-display text-2xl text-terracotta">{s.title}</h2>
            {s.paras.map((p, i) => <Para key={i} p={p} />)}
          </section>
        ))}
      </div>
    </div>
  );
}
